// interfaces
import {
    AddMoneyWalletFormParams,
    LinkableWallet,
    WalletFormData,
    MobikwikCheckSumData,
    AddMoneyResponseData,
} from "@payment-client/interfaces/WalletPublic";

// helpers
import { getMobikwikFormData } from "./MobiKwik";

const sanitizeWalletCode = (walletCode: string): string => {
    return walletCode?.replace("-SSO", "").toLowerCase() ?? "";
};

export const getWalletForm = (
    data: WalletFormData,
    params: AddMoneyWalletFormParams,
): Promise<AddMoneyResponseData> => {
    const walletCode = sanitizeWalletCode(params.walletCode);

    switch (walletCode) {
        case LinkableWallet.MOBIKWIK:
            return getMobikwikFormData(data as MobikwikCheckSumData, params);
        default:
            throw new Error("Invalid wallet code: " + walletCode);
    }
};
